/** " · Round n" from Go's human round — `round`/`total_round` also count creator quotes, so they are never shown. */
export function roundSuffix(r?: { humanRound?: number }): string {
  const humanRound = r?.humanRound;
  return Number.isFinite(humanRound) && (humanRound as number) > 0 ? ` · Round ${humanRound}` : '';
}
